import { inject } from "vue";
import { F as FormContextKey } from "../../../vee-validate.esm-BdNRJGXy.js";
import { ForcedStandaloneKey } from "../Symbols.mjs";
function useGetWithinForm() {
  const parentFormExist = inject(FormContextKey, null) !== null;
  const forceStandalone = inject(ForcedStandaloneKey, false);
  return !forceStandalone && parentFormExist;
}
export {
  useGetWithinForm as default
};
//# sourceMappingURL=useGetWithinForm.mjs.map
